export default __webpack_public_path__ + "static/inside-bg-4-5072248e04fd9f3c7e52b8eace2d9811.jpg";